"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toggle = void 0;

var _react = _interopRequireDefault(require("react"));

var _framerMotion = require("framer-motion");

var _ = require("../");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Toggle = function Toggle(_ref) {
  var options = _ref.options,
      value = _ref.value,
      onChange = _ref.onChange,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'center' : _ref$align;
  return /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: rootCSS({
      align: align
    })
  }, /*#__PURE__*/_react["default"].createElement(_.View, {
    extend: contentCSS
  }, /*#__PURE__*/_react["default"].createElement(_.View, {
    as: _framerMotion.motion.div,
    extend: sliderCSS,
    animate: {
      transform: "translateX(".concat(value === options[0].value ? 0 : 100, "%)")
    }
  }), options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(_.Text, {
      onClick: function onClick() {
        return onChange(option.value);
      },
      extend: optionCSS({
        active: option.value === value
      }),
      bold: option.value === value,
      key: option.value // as="button"

    }, option.label);
  })));
};

exports.Toggle = Toggle;

var rootCSS = function rootCSS(_ref2) {
  var align = _ref2.align;
  return function () {
    return _objectSpread(_objectSpread({
      display: 'flex',
      justifyContent: 'center'
    }, align === 'left' && {
      justifyContent: 'flex-start'
    }), align === 'right' && {
      justifyContent: 'flex-end'
    });
  };
};

var contentCSS = function contentCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
      colors = _ref3$theme.colors,
      layout = _ref3$theme.layout,
      shadows = _ref3$theme.shadows;
  return {
    position: 'relative',
    display: 'flex',
    // width: 200,
    // background: "hotpink",
    height: 45,
    borderRadius: layout.radius,
    overflow: 'hidden',
    boxShadow: shadows.big,
    background: colors.bg,
    border: '6px solid transparent',
    transition: 'box-shadow 200ms ease-in-out',
    '&:hover': {
      boxShadow: shadows.small
    }
  };
};

var optionCSS = function optionCSS(_ref4) {
  var active = _ref4.active;
  return function (_ref5) {
    var grid = _ref5.theme.grid;
    return {
      flex: 1,
      width: '50%',
      display: 'flex',
      padding: grid,
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1,
      color: active ? 'white' : 'inherit',
      transition: 'color 200ms ease-in-out',
      cursor: 'pointer',
      background: 'none',
      border: 'none',
      paddingLeft: 3 * grid,
      paddingRight: 3 * grid // background: active ? colors.primary : "transparent",

    };
  };
};

var sliderCSS = function sliderCSS(_ref6) {
  var _ref6$theme = _ref6.theme,
      colors = _ref6$theme.colors,
      layout = _ref6$theme.layout;
  return {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '50%',
    height: '100%',
    zIndex: 0,
    background: colors.primary,
    borderRadius: layout.radius
  };
};